// extracted by mini-css-extract-plugin
export var attribution = "_9b-4";
export var authorName = "_9b-5";
export var quote = "_9b-3";
export var testimonial = "_9b-2";
export var trustedBy = "_9b-0";
export var trustedByLabel = "_9b-1";